export default __webpack_public_path__ + "static/media/barras.05fad982.png";